export const updateScores = (scores, categoryId) => ({
  type: 'UPDATE_SCORES',
  scores,
  categoryId
})